module.exports = function pluralize(input, count) {
  const pluralize = require("pluralize")
  return pluralize(input, count)
}
